import getScript from "@/services/insertScript.service";
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class GoogleMapApiMixin extends Vue {
    public async loadGoogleMapsApi(): Promise<unknown> {
        return await getScript(
            `https://maps.googleapis.com/maps/api/js?key=` +
            `${process.env.VUE_APP_GOOGLE_MAPS_API_KEY}` +
            `&libraries=drawing,places,geometry` +
            `&v=3.64` // Specify version due to deprecation of drawing manager in later versions (TEMP FIX)
        )
    }
}